import { ThemeDefinition } from 'vuetify';

// Barn och fritid
export const childrenAndRecreation: ThemeDefinition = {
  dark: false,
  colors: {
    'subject-original': '#F3BF39',
    'on-subject-original': '#FFFFFF',
    subject: '#996E00',
    'on-subject': '#FFFFFF',
    primary: '#6F5106',
    'on-primary': '#FFFFFF',
    'primary-container': '#FBE8B7',
    'on-primary-container': '#3A2A03',
    secondary: '#5F563F',
    'on-secondary': '#FFFFFF',
    'secondary-container': '#E0DCD1',
    'on-secondary-container': '#252118',
    surface: '#FCFBF7',
    'on-surface': '#201F1D',
    'on-surface-medium': '#504E49',
    'on-surface-low': '#9E9B94',
    outline: '#868279',
    'outline-variant': '#CFCDC9',
    'inverse-surface': '#423A24',
    'inverse-on-surface': '#F6F4EE',
    'inverse-primary': '#F9E09F',
    'surface-dim': '#EBDFC2',
    'surface-bright': '#FEFDFB',
    'surface-container-lowest': '#FFFFFF',
    'surface-container-low': '#FAF7F0',
    'surface-container': '#F7F3E8',
    'surface-container-high': '#F2EBD9',
    'surface-container-highest': '#F0E7D1',
  },
};

export const childrenAndRecreationDark: ThemeDefinition = {
  dark: true,
  colors: {
    'subject-original': '#F3BF39',
    'on-subject-original': '#FEFCF5',
    subject: '#F3C13F',
    'on-subject': '#3A2B03',
    primary: '#F8D887',
    'on-primary': '#3A2B03',
    'primary-container': '#6A4E06',
    'on-primary-container': '#FEF7E7',
    secondary: '#D6D0C2',
    'on-secondary': '#252118',
    'secondary-container': '#59503B',
    'on-secondary-container': '#F5F3F0',
    surface: '#181610',
    'on-surface': '#F3F3F2',
    'on-surface-medium': '#CFCDC9',
    'on-surface-low': '#868279',
    outline: '#9E9B94',
    'outline-variant': '#6B6861',
    'inverse-surface': '#EDE9DE',
    'inverse-on-surface': '#282315',
    'inverse-primary': '#604706',
    'surface-dim': '#15130E',
    'surface-bright': '#46402F',
    'surface-container-lowest': '#12110C',
    'surface-container-low': '#1F1C14',
    'surface-container': '#28241B',
    'surface-container-high': '#342F23',
    'surface-container-highest': '#433D2D',
  },
};
